LIMIT_ORDERS_COUNT = 20
App.OrdersMapController = Em.Controller.extend
  needs: [ 'orders' ]

  ordersController: Em.inject.controller('orders')
  selectedOrdersCategoryBinding: 'ordersController.selectedOrdersCategory'

  # ---
  # Сервисы
  # ---
  orderMonitor: Em.inject.service('orderMonitor')
  env:          Em.inject.service('environment')
  session:      Em.inject.service('session')

  restaurantsBinding:   'controllers.orders.restaurants'
  couriersBinding:      'controllers.orders.couriers'
  ordersBinding:        'orderMonitor.orders'
  currentOrdersBinding: 'orderMonitor.currentOrders'
  delayedOrdersBinding: 'orderMonitor.delayedOrders'
  limitOrders: true

  hideMapInOrders: localStorage.getItem('hideMapInOrders') == 'true'

  lowPerformanceMode: localStorage.getItem('lowPerformanceMode') == 'true'

  computedOrders: (->
    orders = @get('orders')
    if localStorage.getItem('hideLaterOrdersOnMap') == 'true'
      return orders.filter (order) =>
        order.get('delivery_asap') and not(order.get('status') in ['complete', 'undo'])
    else
      return orders
  ).property('hideLaterOrdersOnMap', 'orders.[]')

  selectedOrdersCategoryObserver: (->
    @set('limitOrders', true)
  ).observes('selectedOrdersCategory')

  isLimitOrdersOn: (->
    @get('selectedOrdersCategory') == 'current' &&
      @get('lowPerformanceMode') &&
      @get('limitOrders') &&
      @get('currentOrders.length') > LIMIT_ORDERS_COUNT
  ).property(
    'selectedOrdersCategory', 'currentOrders.[]', 'delayedOrders.[]', 'limitOrders', 'lowPerformanceMode')

  mapProvider: (->
    return 'google' if @get('session.availableOrganizations')[0].get('features.use_google_in_board')
    return 'yandex' if @get('session.availableOrganizations')[0].get('features.use_yandex_in_board')
    'two-gis'
  ).property('session.availableOrganizations')

  isGoogleMapProvider: Em.computed.equal('mapProvider', 'google')
  isYandexMapProvider: Em.computed.equal('mapProvider', 'yandex')
  isTwoGisProvider: Em.computed.equal('mapProvider', 'two-gis')

  isMapComponentHidden: (->
    @get('hideMapInOrders') and @get('lowPerformanceMode')
  ).property('selectedOrdersCategory', 'currentOrders.[]', 'delayedOrders.[]', 'hideMapInOrders', 'lowPerformanceMode')

  courierPositions: Em.computed.oneWay('controllers.orders.courierPositions')

  selectedOrder: null

  isOrderPopupHidden: Em.computed.equal('selectedOrder', null)


  zeroDataTitle: (->
    @get('env').translate("orders_map.no_#{@get('selectedOrdersCategory')}.title")
  ).property('selectedOrdersCategory')

  zeroDataText: (->
    @get('env').translate("orders_map.no_#{@get('selectedOrdersCategory')}.text")
  ).property('selectedOrdersCategory')

  visibleOrders: (->
    switch @get('selectedOrdersCategory')
      when 'current'
        if @get('isLimitOrdersOn')
          return @get('currentOrders').slice(0,LIMIT_ORDERS_COUNT)
        @get('currentOrders')
      when 'delayed'
        @get('delayedOrders')
  ).property(
    'selectedOrdersCategory', 'currentOrders.[]', 'delayedOrders.[]')

  # Map
  # lat: 55.752637
  # lng: 37.61883
  lat: 0
  lng: 0
  zoom: 12

  actions:
    doLimitOrders: ->
      @set('limitOrders', false)

    selectOrder: (order) ->
      if order
        @transitionToRoute 'orders.map.order', order
      else
        @transitionToRoute 'orders.map'

    sendMap: (map) ->
      @get('ordersController').send('mapRegistred', map)


